export default "__VITE_ASSET__56afc102__"